import React from 'react';
import { Heart } from 'lucide-react';

// "Favorites only" list filter (#104). Rendered only for signed-in users (each
// list page gates it on isAuthenticated). Toggling it drives the ?favorites=
// URL param, which the content list API resolves server-side against the user's
// favorites in the active system — so pagination and the result count stay
// correct (a client-side filter over an already-paginated page could not).
const FavoritesFilterToggle = ({ checked, onChange, className = '' }) => (
  <label className={`filter-checkbox-label ${className}`}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="filter-checkbox"
    />
    <Heart
      className={`w-4 h-4 ${checked ? 'fill-current' : ''}`}
      style={{ color: '#C9A84C' }}
      aria-hidden="true"
    />
    <span className="filter-checkbox-text">Favorites only</span>
  </label>
);

export default FavoritesFilterToggle;
